function syncTomcatServerFormButtons(form: HTMLFormElement): void {
    const selected = form.querySelector<HTMLInputElement>('input[name="server"]:checked');
    form.querySelectorAll<HTMLInputElement>('[data-tomcat-action-button]').forEach((button) => {
        button.disabled = selected == null;
    });
}

export function initTomcatOverview(): void {
    document.querySelectorAll<HTMLFormElement>('[data-tomcat-server-form]').forEach((form) => {
        form.addEventListener('change', (event) => {
            const target = event.target;
            if (target instanceof HTMLInputElement && target.name === 'server') {
                syncTomcatServerFormButtons(form);
            }
        });
        syncTomcatServerFormButtons(form);
    });
}
